"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _types = require("./types");
var _actionUtils = require("../../utils/actionUtils");
/**
 * Creates an action to set the video input device for broadcasting.
 *
 * @param {Object|string} device - The video input device to set. Can be either a device object
 *                                 with a device property(transformed) or a deviceId string directly.
 * @returns {Object} Redux action with type BROADCAST_SET_VIDEO_DEVICE and the device as payload.
 *
 * @example
 * // Using a device ID string
 * dispatch(setVideoInputDevice('device-id-123'));
 *
 * // Using a transformed device object
 * dispatch(setVideoInputDevice({ device: 'device-id-123', label: 'Camera' }));
 */
function setVideoInputDevice(device) {
  return (0, _actionUtils.actionCreator)(_types.BROADCAST_SET_VIDEO_DEVICE, device);
}
var _default = exports["default"] = setVideoInputDevice;